import { render, staticRenderFns } from "./ImagePicker.vue?vue&type=template&id=6780cafe&scoped=true&"
import script from "./ImagePicker.vue?vue&type=script&lang=js&"
export * from "./ImagePicker.vue?vue&type=script&lang=js&"
import style0 from "./ImagePicker.vue?vue&type=style&index=0&id=6780cafe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6780cafe",
  null
  
)

export default component.exports